<template>
    <headertermsandConditions />
    <div class="lg:pl-[8px] 2xl:pl-0 2xl:pr-[12px] m-[40px]">
        <h4
            class="mt-[80px] laptop:mt-[90px] tablet:text-[20px] laptop:text-[24px] font-semibold font-poppins text-center text-[#333333]">
            Privacy Policy</h4>
        <div class="contractoragreementPg min-h-screen pt-[20px] pb-[20px] mt-[20px] font-poppins !bg-white px-[20px] shadow-custom rounded-[10px]"
            ref="contentContainer" v-html="cleanHtml">
        </div>
    </div>
    <footertermsandConditions />
</template>

<script>
import headertermsandConditions from "../../components/layouts/header/terms-and-conditions-header.vue";
import footertermsandConditions from "../../components/layouts/footer/terms-and-conditions-footer.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        headertermsandConditions,
        footertermsandConditions
    },
    data() {
        return {
            cleanHtml: "",
        };
    },
    computed: {
        ...mapGetters(["updatePrivacyPolicyDetails"]),
    },
    watch: {
        "updatePrivacyPolicyDetails.terms_and_conditions_text": {
            handler(newVal) {
                if (!newVal) return;

                // Extract only body content
                const parser = new DOMParser();
                const doc = parser.parseFromString(newVal, "text/html");
                this.cleanHtml = doc.body.innerHTML;

                this.$nextTick(() => {
                    this.enableAnchorScrolling();
                });
            },
            immediate: true,
        },
    },
    mounted() {
        this.getPrivacyPolicyDetails();
        window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    methods: {
        ...mapActions(["getPrivacyPolicyDetails"]),

        enableAnchorScrolling() {
            const container = this.$refs.contentContainer;
            if (!container) return;

            const links = container.querySelectorAll('a[href^="#"]');
            links.forEach((link) => {
                // Remove old listener
                link.removeEventListener("click", link._anchorHandler);

                link._anchorHandler = (e) => {
                    e.preventDefault();

                    const hash = link.getAttribute("href");
                    const target = document.getElementById(hash.replace("#", ""));
                    if (!target) return;

                    // Scroll relative to container
                    const topOffset = target.getBoundingClientRect().top + window.scrollY;

                    // Optional: adjust for fixed header, e.g. 80px
                    const headerOffset = 0;

                    window.scrollTo({
                        top: topOffset - headerOffset,
                        behavior: "smooth",
                    });
                };

                link.addEventListener("click", link._anchorHandler);
            });
        },
    },
};
</script>
